import CMSection from '@src/components/Atoms/CMSection';
import styled from 'styled-components';
import QuoteSvg from '@src/assets/imgs/sponser/quotes.svg';
import Image from 'next/image';
import { devices } from '@src/styles/theme';
const Six = () => {
  return (
    <CMSection backgroundColor="#f9f9f9">
      <Wrap>
        <Flex>
          <QuoteIcon />
          <PcBigTitle>
            4년 전, 7살 아이가 피가 부족하다는 사연을 보고
            <br /> 헌혈문제에 관심을 가지게 되었어요.
          </PcBigTitle>
          <MbBigTitle>
            4년 전, 7살 아이의 피가 <br />
            부족하다는 사연을 보고 <br />
            헌혈문제에 관심을 가지게 되었어요.
          </MbBigTitle>
          <QuoteReverseIcon />
        </Flex>
        <NewsWrap>
          <PcNewsTitle>
            “혈액 사각지대에 있는 이들 위해 <span>붉은 인연</span> 만들고
            싶었어요.”
          </PcNewsTitle>
          <MbNewsTitle>
            “혈액 사각지대에 있는 이들 위해
            <br /> <span>붉은 인연</span> 만들고 싶었어요.”
          </MbNewsTitle>
          <NewsFlex>
            <NewsImage
              width={620}
              height={420}
              src={'/imgs/sponser/news.svg'}
              alt={'news'}
            />
            <NewsMbImage
              width={620}
              height={420}
              src={'/imgs/sponser/news-mb.svg'}
              alt={'news'}
            />
            <NewsContent>
              “일곱 살배기 아이가 혈액이 없어 수술을 못하고 있다는 안타까운
              호소를 온라인 커뮤니티에서 우연히 봤어요.가슴 아픈 사연을 계속
              접하면서 혈액 수급 문제에 관심을 갖게 됐죠.” 헌혈 참여 플랫폼
              ‘피플’ 대표 김범준(21)씨는 “혈액 사각지대에 있는 이들에게 도움을
              주는 ‘붉은 인연’을 만들고 싶었다”며 이렇게 말했다.
              <br />
              <br />
              {/* <br /> */}
              서울과학기술대학 산업정보시스템학과 재학생인 김씨를 포함한 대학생
              6명이 합심해 만든 피플은 수혈 받을 피가 부족한 환자와 헌혈
              지원자를 연결해주는 온라인 홈페이지다.
            </NewsContent>
          </NewsFlex>
        </NewsWrap>
        <PcPpleText>
          피플은 대학생 7명이 힘을 모아 만든 플랫폼이며 유일무이한 민간
          헌혈단체입니다.
          <br />
          <span>피플의 선한 영향력이 지속되기 위해서는 후원이 필요합니다.</span>
        </PcPpleText>
        <MbPpleText>
          피플은 대학생 7명이 힘을 모아 만든 플랫폼이며
          <br />
          유일무이한 민간 헌혈단체입니다.
          <span
            style={{
              display: 'inline-block',
              marginTop: 10,
            }}
          >
            피플의 선한 영향력이 지속되기 위해서는
            <br /> 후원이 필요합니다.
          </span>
        </MbPpleText>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 110px 0;

  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;

const PcBigTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  white-space: pre-wrap;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbBigTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    white-space: pre-wrap;
    color: ${({ theme }) => theme.commonColor.black};
    text-align: center;
    font-family: 'NOTO';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;

  @media ${devices.tablet} {
    gap: 4px;
  }
`;

const QuoteIcon = styled(QuoteSvg)`
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;
const QuoteReverseIcon = styled(QuoteSvg)`
  transform: rotate(180deg);
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;

const NewsWrap = styled.div`
  background-color: ${({ theme }) => theme.commonColor.white};
  padding: 40px;
  max-width: 1200px;
  @media ${devices.tablet} {
    padding: 18px;
    border-radius: 8px;
  }
`;

const PcNewsTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'NOTO';
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.9px;
  > span {
    color: ${({ theme }) => theme.commonColor.pink005};
  }
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbNewsTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    letter-spacing: -0.9px;
    text-align: center;
    > span {
      color: ${({ theme }) => theme.commonColor.pink005};
    }
  }
`;

const NewsFlex = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  gap: 40px;

  @media ${devices.tablet} {
    display: block;
    margin-top: 18px;
  }
`;

const NewsImage = styled(Image)`
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;
const NewsMbImage = styled(Image)`
  display: none;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const NewsContent = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'Regular';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 160% */
  letter-spacing: -0.3px;
  @media ${devices.tablet} {
    font-size: 12px;
    line-height: 20px; /* 166.667% */
    letter-spacing: -0.13px;
    margin-top: 8px;
  }
`;

const PcPpleText = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  white-space: pre-wrap;
  max-width: 900px;
  > span {
    font-weight: 700;
  }

  @media ${devices.tablet} {
    display: none;
  }
`;

const MbPpleText = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: var(--Black, #222);
    text-align: center;
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    > span {
      font-weight: 700;
    }
  }
`;

export default Six;
